import type { ProductSummary } from './queries'

/** Category and product type from the product's place in the store's category tree. */
export function productCategoryContext(product: ProductSummary) {
  if (product.taxonomy.status !== 'assigned') return { category: 'Uncategorized', productType: null }
  const leaf = product.taxonomy.label ?? (product.taxonomy.path ?? []).at(-1)?.label ?? 'Uncategorized'
  const category = (product.taxonomy.path ?? []).at(-2)?.label ?? leaf
  return { category, productType: category !== leaf ? leaf : null }
}

export function leadTimeLabel(product: Pick<ProductSummary, 'fulfillment'>) {
  const { minimum_days: minimum, maximum_days: maximum } = product.fulfillment.lead_time
  return `${minimum === maximum ? minimum : `${minimum}-${maximum}`} business ${maximum === 1 ? 'day' : 'days'}`
}
